import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Type from 'components/Type'
import { find } from 'lodash'
import { useAction } from 'utils/actions'
import { useHeaderNavigation } from 'utils/hooks'
import { TABS } from './Navigation'

const MobileNav = () => {
  const navigate = useHeaderNavigation()
  const { pathname } = useLocation()
  const { openChat } = useAction()

  const value = useMemo(() => {
    return find(TABS, o => pathname === o.to || pathname.startsWith(o.root || o.to))?.to || ''
  }, [pathname])

  return (
    <AppBar 
      sx={{ 
        display: {
          md: 'none',
        },
        position: 'fixed',
        bgcolor: 'background.paper.main',
        color: 'background.paper.text',
        top: 'auto', 
        bottom: 0, 
        height: 80,
        zIndex: 'header',
      }}
    >
      <Toolbar
        sx={{
          display: 'grid',
          gap: 1,
          gridAutoFlow: 'column',
          justifyContent: 'space-around',
          alignItems: 'flex-start',
          height: 'inherit',
          px: 1.5,
          py: .5,
        }}
      >
        {TABS.map(o => (
          <Box
            key={`mobile${o.label}`}
            tabindex="0"
            sx={theme => ({
              display: 'inline-grid',
              gap: .5,
              justifyContent: 'center',
              justifyItems: 'center',
              cursor: 'pointer',
              '.nav-item__icon': {
                width: 64,
                height: 32,
                borderRadius: '32px',
                display: 'grid',
                placeItems: 'center',
                placeContent: 'center',
                textAlign: 'center',
                bgcolor: value === o.to ? theme.palette.background.neutralCool_200.main : undefined,
                transition: theme.internalMixins.setTransition(['background-color']),
              },
              '.nav-item__label': {
                textAlign: 'center',
                color: value === o.to ? undefined : 'text.neutralCool_700',
              },
              '&:hover': {
                '.nav-item__icon': {
                  bgcolor: theme.palette.background.neutralCool_200.main,
                },
                '.nav-item__label': {
                  color: 'text.secondary',
                },
              },
            })}
            onClick={() => {
              o.openChat ? openChat() : navigate(o.to)
            }}
          >
            <Box
              className="nav-item__icon"
            >
              {o.icon}
            </Box>
            <Type
              className="nav-item__label"
              variant="labelSmall"
            >
              {o.label}
            </Type>
          </Box>
        ))}
      </Toolbar>
    </AppBar>
  )
}

export default MobileNav